export const testPhone = (event) => {
    const regex = new RegExp("[A-zА-я]", 'g');
    const value = event.target.value;
    if (regex.test(value)) {
        event.preventDefault();
        return false;
    } else {
        return true;
    }
}